import { createStore } from "vuex"
import toolList from "./modules/toolList.js"
import orderBook from "./modules/orderBook.js";
import tradeList from "./modules/tradeList.js";
import socket from "./modules/socket.js";
import tradeUser from "./modules/tradeUser.js";
import exchangeUser from "./modules/exchangeUser.js";
import authentication from "./modules/authentication.js";
import account from "./modules/account.js";
import currency from "./modules/currency.js";
import app from "./modules/app.js";
import auth from "./modules/auth.js";
import faq from "./modules/faq.js";
import news from "./modules/news.js";
import country from "./modules/country.js";
import chat from "./modules/chat.js";

export default createStore({
    modules: {
        authentication,
        toolList,
        orderBook,
        tradeList,
        socket,
        tradeUser,
        exchangeUser,
        account,
        currency,
        app,
        auth,
        faq,
        news,
        country,
        chat
    }
});
